import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Breadcrumbs from "./breadcrumbs";
import Button from "../../../../../components/Buttons/button";
import image from "../../../../../assets/images/Rectangle 1 (1).svg";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../../../../redux/slices/userSlice";

function Header({
  path,
  data,
  setPopup,
  setManageId,
  setState,
  owner_authorized,
  setupServices,
  setTab,
  reportMissingMonth,
  reportDay,
  reportMissingMonthData,
  serviceDataBillingMonth,
}) {
  const userData = useSelector(selectUser);
  const { profile } = userData;
  const currentDate = new Date();
  const currentDay = currentDate.getDate();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const isOwnerAuthorized =
    owner_authorized?.length > 0
      ? owner_authorized.every((owner) => owner.id === profile.id)
      : false;
  const showManageButton =
    (profile.admin || isOwnerAuthorized) && !setupServices;

  function handleManage(serviceId, count) {
    setTab(count);
    setPopup(true);
    setState(35);
    setManageId(serviceId);
  }

  const getDaysRemainingInMonth = () => {
    const today = new Date();
    const currentDay = today.getDate();
    const lastDayOfMonth = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0
    ).getDate();
    const remainingDays = lastDayOfMonth - currentDay;
    return remainingDays;
  };

  const calculateRemainingDays = (reportDay, currentDay) => {
    let remainingDays = reportDay - currentDay;
    if (remainingDays < 0) {
      // const daysInCurrentMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
      // remainingDays = (daysInCurrentMonth - currentDay) + Number(reportDay);
      return "overdue";
    }
    return remainingDays;
  };

  const remainingDays = calculateRemainingDays(reportDay, currentDay);
  return (
    <header className="sticky top-[0px] w-[100%] z-[2] header-gradient flex flex-col gap-[16px]">
      {path && (
        <div className="w-[100%] flex pt-3 md:pt-6 px-3 md:px-0">
          <Breadcrumbs path={path} />
        </div>
      )}
      <div className="w-[100%] flex flex-col gap-[12px] px-3 md:px-0">
        {data?.category_name && (
          <div className="flex flex-col justify-between md:flex-row pb-[8px] gap-[12px] md:gap-[24px] md:items-center">
            <div className="flex flex-row justify-start gap-[12px] md:gap-[24px] items-start md:items-center">
              {data?.name !== "Personal Expenses" && (
                <img
                  src={data?.image_url}
                  alt="service"
                  className="rounded-lg w-[36px] h-[36px] md:w-[72px] md:h-[72px] card_img"
                />
              )}
              {data?.name === "Personal Expenses" && (
                <div className="w-[72px] h-[72px] flex justify-center items-center rounded-lg bg-[#242B3E]">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M4.6665 8.00163C4.6665 6.1611 6.15846 4.66699 7.99984 4.66699H23.9998C25.8412 4.66699 27.3332 6.1611 27.3332 8.00163V26.7531C27.3332 27.8154 26.1486 28.4563 25.2602 27.864L23.1079 26.4292C22.8664 26.2681 22.5484 26.2819 22.3217 26.4633L20.5826 27.8546C19.8521 28.4389 18.8142 28.4389 18.0838 27.8546L16.4163 26.5206C16.1728 26.3258 15.8269 26.3258 15.5834 26.5206L13.9159 27.8546C13.1855 28.4389 12.1476 28.4389 11.4171 27.8546L9.67802 26.4633C9.45132 26.2819 9.13332 26.2681 8.89176 26.4292L6.73944 27.864C5.85112 28.4563 4.6665 27.8154 4.6665 26.7531V8.00163ZM7.99984 6.00033C6.89569 6.00033 5.99984 6.89664 5.99984 8.00163V26.7531L8.15216 25.3198C8.87684 24.8366 9.83085 24.878 10.5109 25.4221L12.25 26.8134C12.4935 27.0082 12.8395 27.0082 13.083 26.8134L14.7504 25.4794C15.4809 24.8951 16.5188 24.8951 17.2492 25.4794L18.9167 26.8134C19.1602 27.0082 19.5062 27.0082 19.7496 26.8134L21.4887 25.4221C22.1688 24.878 23.1228 24.8366 23.8475 25.3198L25.9992 26.7542L25.9998 8.00163C25.9998 6.89664 25.104 6.00033 23.9998 6.00033H7.99984ZM9.99984 12.0003C9.99984 11.6321 10.2983 11.3337 10.6665 11.3337H16.6665C17.0347 11.3337 17.3332 11.6321 17.3332 12.0003C17.3332 12.3685 17.0347 12.667 16.6665 12.667H10.6665C10.2983 12.667 9.99984 12.3685 9.99984 12.0003ZM19.9998 12.0003C19.9998 11.6321 20.2983 11.3337 20.6665 11.3337H21.3332C21.7014 11.3337 21.9998 11.6321 21.9998 12.0003C21.9998 12.3685 21.7014 12.667 21.3332 12.667H20.6665C20.2983 12.667 19.9998 12.3685 19.9998 12.0003ZM9.99984 17.3337C9.99984 16.9655 10.2983 16.667 10.6665 16.667H21.3332C21.7014 16.667 21.9998 16.9655 21.9998 17.3337C21.9998 17.7018 21.7014 18.0003 21.3332 18.0003H10.6665C10.2983 18.0003 9.99984 17.7018 9.99984 17.3337Z"
                      fill="white"
                    />
                  </svg>
                </div>
              )}
              <div className="flex flex-col">
                <div className=" flex text-primary !text-[18px] !leading-[26px] md:!text-[24px] md:!leading-[36px]">
                  {data?.name} ({serviceDataBillingMonth})
                  {showManageButton && (
                    <div>
                      <Button
                        className="custom_btn_wrap inline_text pl-[20px] pt-[2px] pb-[0px] !text-[#FFD74A] "
                        onClick={() => handleManage(data.id, 1)}
                      >
                        <div className="icon-wrapp">
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M8.7075 21.0048L8.66181 21.0003L8.61591 21C8.34481 20.9984 8.08162 20.9087 7.86595 20.7444L5.79721 19.2054C5.52536 18.9903 5.34504 18.68 5.29285 18.3371C5.24018 17.9909 5.32209 17.6378 5.52168 17.3501L5.52799 17.3407C5.79937 16.94 5.97183 16.4807 6.03122 16.0004C6.09061 15.5201 6.03528 15.0326 5.86969 14.5778L5.81974 14.4446C5.69718 14.0338 5.48279 13.6559 5.19256 13.3398C4.89162 13.012 4.51762 12.7597 4.10091 12.6036L3.93122 12.54H3.77709C3.50198 12.4138 3.27627 12.1974 3.13892 11.9246C2.98024 11.6093 2.95235 11.2443 3.06124 10.9086L3.89272 8.27217L3.90001 8.24306C3.94087 8.08001 4.0161 7.92756 4.12065 7.79594C4.2252 7.66431 4.35667 7.55655 4.50625 7.47985L4.50803 7.47894C4.64512 7.4083 4.79512 7.36622 4.94895 7.35523C5.10278 7.34424 5.25723 7.36462 5.40297 7.41505L5.41104 7.41777C5.86326 7.56996 6.34582 7.60941 6.81676 7.53268C7.2877 7.45596 7.7328 7.2654 8.11333 6.97753L8.25676 6.8672L8.26371 6.86166C8.60756 6.58729 8.88546 6.23926 9.07693 5.84321C9.26839 5.44717 9.36855 5.01321 9.37 4.57331L9.37001 4.33L9.37 4.32561C9.36847 3.97747 9.50453 3.64283 9.74856 3.39454C9.99129 3.14757 10.3213 3.00593 10.6674 3H13.2085C13.374 3.0006 13.5379 3.03382 13.6906 3.09778C13.8432 3.16166 13.9816 3.25495 14.0981 3.37233C14.3519 3.63105 14.4928 3.97981 14.49 4.34225V4.6218C14.4837 5.05076 14.5775 5.47534 14.7639 5.8618C14.9519 6.25133 15.2288 6.59123 15.5722 6.8541L15.5819 6.86154L15.6966 6.94492C16.0486 7.20723 16.4584 7.38115 16.8917 7.45201C17.3265 7.5231 17.772 7.48831 18.1905 7.35059L18.1939 7.34947L18.5278 7.24147L18.5347 7.23921C18.6953 7.18597 18.8649 7.16563 19.0336 7.17938C19.2022 7.19314 19.3663 7.24072 19.5162 7.31929C19.666 7.39786 19.7985 7.5058 19.9058 7.63668C20.013 7.76756 20.0928 7.91869 20.1403 8.08107L20.143 8.09013L20.9359 10.6195C21.0412 10.9551 21.0124 11.3185 20.8556 11.6333C20.699 11.9474 20.4272 12.1888 20.0968 12.3071L20.0945 12.3079L19.9082 12.3732C19.4626 12.521 19.0597 12.7751 18.7343 13.1137C18.4068 13.4546 18.1678 13.8706 18.0385 14.3253C17.9195 14.74 17.8913 15.1755 17.956 15.6021C18.0207 16.0293 18.1769 16.4374 18.4139 16.7986L18.4192 16.8067L18.6847 17.1947L18.6865 17.1974C18.8865 17.4875 18.9678 17.8432 18.9139 18.1914C18.8601 18.5392 18.6754 18.8532 18.3978 19.0693L18.3966 19.0702L16.3925 20.6157L16.3911 20.6168C16.257 20.719 16.1035 20.7928 15.9399 20.8337C15.7757 20.8747 15.6049 20.8817 15.4379 20.8542C15.2709 20.8267 15.1113 20.7654 14.9689 20.6739C14.8266 20.5824 14.7044 20.4627 14.61 20.3223L14.6036 20.3127L14.484 20.1433C14.2274 19.7623 13.8795 19.4516 13.4718 19.2396C13.0596 19.0253 12.5998 18.9189 12.1354 18.9303L12.1341 18.9303C11.6954 18.9417 11.2655 19.056 10.8791 19.2641C10.4927 19.4721 10.1606 19.7682 9.90961 20.1282L9.67385 20.4665L9.66827 20.4748C9.57351 20.6168 9.45069 20.7378 9.30737 20.8305C9.17386 20.9169 9.02519 20.9769 8.86938 21.0075C8.81546 21.0109 8.76132 21.01 8.7075 21.0048ZM4.30423 18.4875C4.39536 19.0863 4.71231 19.6276 5.19 20L7.26 21.54C7.64822 21.8357 8.12203 21.9971 8.61 22C8.73969 22.0127 8.87031 22.0127 9 22C9.30301 21.9493 9.59241 21.8371 9.85039 21.6702C10.1084 21.5034 10.3294 21.2855 10.5 21.03L10.73 20.7C10.8913 20.4686 11.1048 20.2783 11.3532 20.1445C11.6016 20.0108 11.878 19.9373 12.16 19.93C12.4556 19.9227 12.7481 19.9904 13.0104 20.1268C13.2727 20.2632 13.4962 20.4639 13.66 20.71L13.78 20.88C13.9505 21.1337 14.1711 21.3499 14.4283 21.5152C14.6855 21.6804 14.9738 21.7913 15.2755 21.8409C15.5771 21.8906 15.8857 21.878 16.1823 21.8039C16.4789 21.7297 16.7572 21.5957 17 21.41L19.01 19.86C19.49 19.4872 19.8092 18.945 19.9021 18.3444C19.9951 17.7438 19.8548 17.1304 19.51 16.63L19.25 16.25C19.092 16.0092 18.9878 15.7371 18.9447 15.4523C18.9015 15.1675 18.9204 14.8768 19 14.6C19.0845 14.3022 19.2409 14.0298 19.4554 13.8066C19.6698 13.5834 19.9358 13.4163 20.23 13.32L20.43 13.25C21.005 13.0452 21.4784 12.6256 21.7506 12.0793C22.0228 11.533 22.0728 10.9024 21.89 10.32L21.1 7.8C21.0147 7.50876 20.8716 7.23767 20.6793 7.00292C20.487 6.76817 20.2493 6.57456 19.9805 6.43364C19.7118 6.29272 19.4174 6.20737 19.1149 6.1827C18.8124 6.15802 18.5081 6.19451 18.22 6.29L17.88 6.4C17.6136 6.48805 17.33 6.51039 17.0531 6.46511C16.7762 6.41984 16.5144 6.3083 16.29 6.14L16.18 6.06C15.961 5.89237 15.7844 5.67562 15.6646 5.42723C15.5447 5.17884 15.4849 4.90575 15.49 4.63V4.35C15.4949 3.72202 15.2503 3.11779 14.81 2.67C14.6006 2.45845 14.3514 2.29036 14.0768 2.17538C13.8023 2.0604 13.5077 2.0008 13.21 2H10.66C10.0482 2.00791 9.46425 2.25719 9.03535 2.69358C8.60645 3.12997 8.36732 3.71813 8.37 4.33V4.57C8.36904 4.86027 8.30296 5.14663 8.17662 5.40796C8.05027 5.6693 7.8669 5.89895 7.64 6.08L7.51 6.18C7.25935 6.36962 6.96617 6.49516 6.65596 6.5457C6.34575 6.59624 6.02789 6.57025 5.73 6.47C5.45642 6.37533 5.16647 6.33715 4.8777 6.35777C4.58893 6.3784 4.30736 6.4574 4.05 6.59C3.77366 6.73169 3.53078 6.93078 3.33762 7.17396C3.14446 7.41713 3.00549 7.69876 2.93 8L2.11 10.6C1.91985 11.1862 1.96861 11.8237 2.24571 12.3742C2.52281 12.9247 3.00588 13.3436 3.59 13.54H3.75C4.01946 13.641 4.26131 13.8041 4.45591 14.0161C4.65051 14.228 4.79238 14.4829 4.87 14.76L4.93 14.92C5.04148 15.2261 5.07876 15.5543 5.03878 15.8777C4.99879 16.201 4.88269 16.5102 4.7 16.78C4.35472 17.2777 4.21311 17.8887 4.30423 18.4875ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        {/*Manage*/}
                      </Button>
                    </div>
                  )}
                </div>

                <div className="text-secondary !text-[14px] !leading-[21px]">
                  {data?.category_name}
                </div>
              </div>
            </div>
            {showManageButton && !reportMissingMonthData && (
              <div className="flex justify-between gap-[10px] p-[14px_20px_14px_20px] bg-[#242B3E] rounded-[12] md:rounded-[24px] lg:rounded-[32px] ">
                <Button
                  className="inline_text !text-[#FFD74A] w-full flex items-center justify-between"
                  onClick={() => handleManage(data.id, 3)}
                >
                  <div className="flex flex-col text-left flex-1">
                    <span className="text-secondary !text-white !text-[14px] !leading-[21px]">
                      Missing data ({reportMissingMonth?.slice(0, 3)})
                    </span>
                    {(reportDay ) ? (
                      remainingDays === "overdue" ? (
                        <span className="!text-red-500 !font-medium">
                          Overdue
                        </span>
                      ) : (
                        <span className="text-secondary">
                          {" "}
                          {remainingDays} days until generation
                        </span>
                      )
                    ) : null}
                  </div>
                  <div className="icon-wrapp w-[44px] h-[44px] flex items-center justify-center bg-[#363D50] rounded-[16px]">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6 20.3965C4.61929 20.3965 3.5 19.2772 3.5 17.8965L3.5 14.8965C3.5 14.6203 3.72386 14.3965 4 14.3965C4.27614 14.3965 4.5 14.6203 4.5 14.8965L4.5 17.8965C4.5 18.7249 5.17157 19.3965 6 19.3965L18 19.3965C18.8284 19.3965 19.5 18.7249 19.5 17.8965L19.5 14.8965C19.5 14.6203 19.7239 14.3965 20 14.3965C20.2761 14.3965 20.5 14.6203 20.5 14.8965L20.5 17.8965C20.5 19.2772 19.3807 20.3965 18 20.3965L6 20.3965ZM12 15.3965C11.7239 15.3965 11.5 15.1726 11.5 14.8965L11.5 5.10359L8.35355 8.25004C8.15829 8.4453 7.84171 8.4453 7.64645 8.25004C7.45118 8.05478 7.45118 7.73819 7.64645 7.54293L11.2929 3.89648C11.6834 3.50596 12.3166 3.50596 12.7071 3.89648L16.3536 7.54293C16.5488 7.73819 16.5488 8.05477 16.3536 8.25004C16.1583 8.4453 15.8417 8.4453 15.6464 8.25004L12.5 5.10359L12.5 14.8965C12.5 15.1726 12.2761 15.3965 12 15.3965Z"
                        fill="#FFD74A"
                      />
                    </svg>
                  </div>
                </Button>
              </div>
            )}
          </div>
        )}
        {!data?.category_name && (
          <SkeletonTheme baseColor="#3B4255" highlightColor="#0000001a">
            <Skeleton className="!w-[150px] !h-[72px]" />
          </SkeletonTheme>
        )}
        <div className="bg-[#41485C] w-[100%] h-[2px]" />
      </div>
    </header>
  );
}

export default Header;
